import React, { useEffect, useState } from "react";
import styles from "./preferences-box.module.css";
import { url } from "../../api/index.js";
import { toast } from "react-toastify";
import { apiClient } from "../../api/client";

const PreferencesBox: React.FC = ({
}) => {

	const [preferences, setPreferences] = useState({
		useEmoji: false,
	});
	const [fetched, setFetched] = useState(false);
	const [useLegacyLayout, setUseLegacyLayout] = useState(() => {
		const stored = localStorage.getItem("useLegacyLayout");
		return stored === "true";
	});

	const getPreferences = async () => {
		try {
			const response = await apiClient.get(`${url}/api/edit/preferences`);
			if (response.status !== 200) {
				return;
			}
			setPreferences(response.data.artPreferences);
			setFetched(true);
		} catch (error: any) {
			// handle errors silently - session-expired event will be emitted by tokenService
			// if it's a 401, the session manager will handle redirect
			if (error?.response?.status === 401) {
				console.log("[Preferences] Request failed with 401 - session expired, redirecting...");
				return;
			}
			console.warn("[Preferences] Error fetching preferences:", error);
		}
	}

	useEffect(() => {
		getPreferences();
	}, []);

	const onToggleChange = async (checked: boolean) => {
		try {
			const response = await apiClient.put(`${url}/api/edit/preferences`, { useEmoji: checked });
			console.log(JSON.stringify({ useEmoji: checked }));
			if (response.status === 200) {
				setPreferences({ ...preferences, useEmoji: checked });
				toast.success(
					`Emoji preference updated to ${checked ? "enabled" : "disabled"}`,
					{
						position: 'bottom-center',
					}
				);
			} else {
				toast.error("Failed to update emoji preference");
			}
		} catch (error: any) {
			if (error?.response?.status === 401) {
				// session expired - SessionManager will handle redirect
				return;
			}
			toast.error("Failed to update emoji preference");
		}
	};

	const onLegacyLayoutToggle = (checked: boolean) => {
		localStorage.setItem("useLegacyLayout", checked.toString());
		setUseLegacyLayout(checked);
		// dispatch custom event so other components can react
		window.dispatchEvent(new Event("legacyLayoutChanged"));
		toast.success(
			`Legacy layout ${checked ? "enabled" : "disabled"}`,
			{
				position: 'bottom-center',
			}
		);
	};

	return (fetched ? (
		<div className={styles.preferences}>
			<label className={styles.toggleLabel}>
				Use your emoji:
				<input
					type="checkbox"
					checked={preferences.useEmoji}
					onChange={(e) => onToggleChange(e.target.checked)}
				/>
			</label>
			<label className={styles.toggleLabel}>
				Use legacy layout (mobile):
				<input
					type="checkbox"
					checked={useLegacyLayout}
					onChange={(e) => onLegacyLayoutToggle(e.target.checked)}
				/>
			</label>
			{/* haptics live in their own profile panel (HapticsSettings) — this box
			    is behind ?p=1 and a backend fetch, which hid the toggle entirely */}
		</div>
	) : null);
};

export default PreferencesBox;
